import { IPropertyPalCareersPage } from '@propertypal/shared/src/types/strapi';
import { SubHeading } from '@propertypal/web-ui/src/typography';
import React from 'react';
import { Container, MainText } from './HowToApplySection.style';

interface HowToApplySectionProps {
  howToApplySection: IPropertyPalCareersPage['attributes']['howToApply'];
}

const HowToApplySection: React.FC<HowToApplySectionProps> = ({ howToApplySection }) => {
  return (
    <Container data-testid="how-to-apply-section">
      <SubHeading>{howToApplySection?.title}</SubHeading>
      <MainText html={howToApplySection?.content} />
    </Container>
  );
};

export default HowToApplySection;
